import React, { useCallback } from 'react'
import styled from 'styled-components'
import { defaultTransition } from '../../theme'
import { Box } from '../UI/Box'
import useIsLoggedIn from '../../hooks/useIsLoggedIn'
import { toast } from 'react-toastify'
import AnimatedLoader from '../AnimatedLoader'
import ThemedButton from '../ThemedButton'
import useWeb3 from '../../hooks/useWeb3'
import { useSocialAccounts } from '@dynamic-labs/sdk-react-core'
import { ProviderEnum } from '@dynamic-labs/sdk-api-core'

const Link = styled.div`
  color: ${({ theme }) => theme.colors.brandPrimary};
  span.active {
    color: ${({ theme }) => theme.colors.brandPrimary};
    ${defaultTransition}
    :hover {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.brandSecondary};
    }
  }
`

const ConnectedAccount = styled(Box)`
  flex-grow: 0;
  button {
    ${defaultTransition}
  }
`

const TiktokConnectButton = ({ label }: { label?: string }) => {
  const {
    getLinkedAccountInformation,
    linkSocialAccount,
    unlinkSocialAccount,
    isProcessing,
    isLinked,
  } = useSocialAccounts()

  const { isLoggedIn } = useIsLoggedIn()
  const acc = getLinkedAccountInformation(ProviderEnum.Tiktok)

  const { initWeb3 } = useWeb3()

  const connectTiktok = useCallback(async () => {
    try {
      await linkSocialAccount(ProviderEnum.Tiktok)
    } catch (err) {
      console.error(err)
      toast.error('Failed to connect Tiktok')
    }
  }, [linkSocialAccount])

  const disconnectTiktok = useCallback(async () => {
    try {
      await unlinkSocialAccount(ProviderEnum.Tiktok)
    } catch (err) {
      console.error(err)
      toast.error('There was an error disconnecting your Tiktok account')
    }
  }, [unlinkSocialAccount])

  if (!isLoggedIn) {
    return (
      <Link>
        <span className="active" onClick={() => initWeb3()}>
          Connect
        </span>
      </Link>
    )
  }

  if (!!isLinked(ProviderEnum.Tiktok)) {
    return (
      <ConnectedAccount ac g={16} className="force-row">
        {acc?.email || acc?.username || acc?.displayName}
        <ThemedButton
          $styleType="surface-chip"
          onClick={disconnectTiktok}
          text={isProcessing ? <AnimatedLoader size={16} /> : 'Disconnect'}
        />
      </ConnectedAccount>
    )
  }

  return (
    <Link>
      <ThemedButton
        $styleType="surface-chip"
        onClick={connectTiktok}
        text={isProcessing ? <AnimatedLoader size={16} /> : label ?? 'Connect'}
      />
    </Link>
  )
}

export default TiktokConnectButton
